import React, { useEffect, useState } from "react";
import { Table, Card, Typography, message, Tag } from "antd";
import { getAllReports } from "../../services/reports";
import dayjs from "dayjs";

const { Title, Text } = Typography;

const AdminReports = () => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchReports = async () => {
    try {
      setLoading(true);
      const res = await getAllReports();

      if (res.success && Array.isArray(res.data)) {
        setReports(res.data);
      } else {
        message.warning("No reports found.");
        setReports([]);
      }
    } catch (err) {
      console.error("Error fetching reports:", err);
      message.error("Failed to fetch reports.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReports();
  }, []);

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => <Text strong>{text || "N/A"}</Text>,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (text) => <Text>{text || "N/A"}</Text>,
    },
    {
      title: "Total Reports",
      dataIndex: "reportCount",
      key: "reportCount",
      render: (count) => (
        <Tag color="blue" style={{ fontSize: "14px", padding: "4px 10px" }}>
          {count ?? 0}
        </Tag>
      ),
    },
    {
      title: "Report Range",
      key: "reportRange",
      render: (_, record) => {
        const { firstReportDate, lastReportDate } = record;
        if (!firstReportDate || !lastReportDate) return <Text>—</Text>;

        return (
          <Text type="secondary">
            {dayjs(firstReportDate).format("DD MMM YYYY")} →{" "}
            {dayjs(lastReportDate).format("DD MMM YYYY")}
          </Text>
        );
      },
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Card
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              <Title level={3} style={{ marginBottom: 0 }}>
                User Reports Summary
              </Title>
              <Text type="secondary">
                View total reports and report date range for each user
              </Text>
            </div>
          </div>
        }
        bordered={false}
        style={{
          borderRadius: 10,
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        }}
      >
        <Table
          columns={columns}
          dataSource={reports}
          rowKey={(record) => record.email || record.name}
          loading={loading}
          pagination={{ pageSize: 8 }}
        />
      </Card>
    </div>
  );
};

export default AdminReports;
